import { Icon } from "@iconify/react"
import { routes } from "../pages/routes"
import { isEmpty } from "lodash"
import { useSelector } from "react-redux"
import { AppDispatch, RootState } from "../store"
import { TBilling } from "../shared/types/billing.type"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { logout } from "../store/reducers/user.reducer"
import { useQueryClient } from "react-query"
import { useAuth } from "./useAuth"

type menuItem = {
    key: string,
    icon: any,
    fn?: () => void,
    link?: string,
    target?: React.HTMLAttributeAnchorTarget
}

export const useMenuItem = (iconSize = 24) => {

    const billings = useSelector<RootState>(state => state.user.user?.user_billing_infos) as TBilling[]
    const { isAdmin } = useAuth()

    //create menu
    const menu: Array<menuItem> = [
        {
            key: 'navbar:profileOptions:profile',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='mingcute:user-3-fill' />,
            link: routes.DASHBOARD_ROUTES.PROFILE
        },
        {
            key: 'navbar:myEquimetres',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='material-symbols:memory' />,
            link: routes.DASHBOARD_ROUTES.EQUIMETRES
        },
        {
            key: 'navbar:settings',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='solar:settings-bold' />,
            link: routes.DASHBOARD_ROUTES.SETTINGS
        },
        ...(isEmpty(billings) ? [] : [{
            key: "menu:billing",
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='majesticons:creditcard' />,
            link: routes.DASHBOARD_ROUTES.BILLINGS
        }]),
        ...(isAdmin ? [{
            key: "Back office",
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='material-symbols:admin-panel-settings-rounded' />,
            link: process.env.REACT_APP_BACKOFFICE_URI,
            target: '_blank'

        }] : []),
        {
            key: 'navbar:profileOptions:helpSupport',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='solar:help-bold' />,
            link: 'https://knowledgebase.equimetre.com/en',
            target: '_blank'
        },
        {
            key: 'contact',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='ix:support' />,
            link: 'https://training.arioneo.com/en/contact-the-arioneo-team-heart-rate-monitor-for-racehorses/?__hstc=53838839.2b4406dd09c7110103f76d133cc748fc.1704303036116.1706012719152.1706015968079.5&__hssc=53838839.2.1706015968079&__hsfp=1007729581',
            target: '_blank'

        },
        {
            key: 'navbar:profileOptions:referral',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='ic:round-group-add' />,
            link: 'https://share.hsforms.com/13Ovnb8zKSaaHb9JTzZA9IA2ie94?__hstc=53838839.2b4406dd09c7110103f76d133cc748fc.1704303036116.1706012719152.1706015968079.5&__hssc=53838839.2.1706015968079&__hsfp=1007729581',
            target: '_blank'
        },
        {
            key: 'navbar:profileOptions:logout',
            icon: <Icon style={{ width: iconSize, height: iconSize }} icon='majesticons:logout-line' />,
            link: routes.AUTH_ROUTES.LOGOUT
        }
    ]


    return {
        menu
    }
}